import { useEffect } from "react";
import PageContainer from "@components/layout/PageContainer";
import styles from "./style.module.scss";
import ProviderInvoiceNoteMessageForm from "@components/forms/ProviderInvoiceNoteMessageForm";

const ValidateENote = () => {

  useEffect(() => {
  }, []);

  return (
    <PageContainer
      containerClassName={styles.mainContainer}
      title="Validar Nota de Credito/Debito de Provedor"
      backUrl="/user/provider-invoices"
    >
      <ProviderInvoiceNoteMessageForm
        formId="providerValidateForm"
        saveRedirectUrl="/user/provider-invoices"
      ></ProviderInvoiceNoteMessageForm>

    </PageContainer >
  );
}

export default ValidateENote;
